module.exports = __webpack_public_path__ + "fonts/primeicons.7817295.woff2";